// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alpaca-bot-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.alpaca-bot-header {
  margin-bottom: 2rem;
}

.alpaca-bot-title {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin: 0 0 0.5rem 0;
}

.alpaca-bot-subtitle {
  color: #666;
  margin: 0;
}

.bot-config-selector {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bot-config-selector label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.bot-config-selector select {
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: white;
  color: #1e293b;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-width: 200px;
}

.bot-config-selector select:hover {
  border-color: #667eea;
}

.bot-config-selector select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.alpaca-bot-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.bot-status {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.bot-status-indicator {
  font-size: 1.5rem;
}

.bot-status-text {
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
}

.bot-actions {
  display: flex;
  gap: 1rem;
}

.bot-button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.bot-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.start-button {
  background: #4CAF50;
  color: white;
}

.start-button:hover:not(:disabled) {
  background: #45a049;
}

.stop-button {
  background: #f44336;
  color: white;
}

.stop-button:hover:not(:disabled) {
  background: #da190b;
}

.error-message {
  padding: 1rem;
  background: #fee;
  color: #c33;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4CAF50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bot-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #4CAF50;
  overflow: hidden;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.4;
  overflow-wrap: break-word;
  word-wrap: break-word;
  min-height: 2.8rem;
  display: flex;
  align-items: flex-start;
}

.stat-value {
  font-size: 1.6rem;
  font-weight: bold;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.2;
  max-width: 100%;
  margin-top: auto;
}

.stat-value.buy {
  color: #4CAF50;
}

.stat-value.sell {
  color: #f44336;
}

.stat-value.profit {
  color: #4CAF50;
}

.stat-value.loss {
  color: #f44336;
}

.stat-sublabel {
  font-size: 0.75rem;
  color: #999;
  margin-top: 4px;
}

.stat-card-total {
  border-left-color: #2196F3;
  background: #f0f7ff;
}

.stat-value-lg {
  font-size: 2rem;
}

.bot-transactions {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  margin: 0 0 1.5rem 0;
}

.transactions-table-container {
  overflow-x: auto;
}

.transactions-table {
  width: 100%;
  border-collapse: collapse;
}

.transactions-table thead {
  background: #f5f5f5;
}

.transactions-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #ddd;
}

.transactions-table tbody tr {
  border-bottom: 1px solid #eee;
}

.transactions-table tbody tr:hover {
  background: #f9f9f9;
}

.transactions-table td {
  padding: 0.75rem 1rem;
}

.action-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.action-badge.buy {
  background: #e8f5e9;
  color: #2e7d32;
}

.action-badge.sell {
  background: #ffebee;
  color: #c62828;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.status-badge.status-filled {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.status-pending,
.status-badge.status-new,
.status-badge.status-accepted,
.status-badge.status-pending_new,
.status-badge.status-pending_replace,
.status-badge.status-accepted_for_bidding {
  background: #fff3e0;
  color: #e65100;
}

.status-badge.status-partially_filled {
  background: #e3f2fd;
  color: #1565c0;
}

.status-badge.status-failed,
.status-badge.status-canceled,
.status-badge.status-expired,
.status-badge.status-rejected {
  background: #ffebee;
  color: #c62828;
}

.profit {
  color: #4CAF50;
  font-weight: 600;
}

.loss {
  color: #f44336;
  font-weight: 600;
}

.empty-message {
  text-align: center;
  padding: 3rem;
  color: #999;
}

.bot-logs {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 2rem;
}

.logs-container {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 1rem;
  background: #f9f9f9;
}

.log-entry {
  display: grid;
  grid-template-columns: 180px 40px 1fr auto;
  gap: 1rem;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
  align-items: center;
  border-left: 3px solid transparent;
}

.log-entry.log-info {
  background: #e3f2fd;
  border-left-color: #2196f3;
}

.log-entry.log-success {
  background: #e8f5e9;
  border-left-color: #4caf50;
}

.log-entry.log-warning {
  background: #fff3e0;
  border-left-color: #ff9800;
}

.log-entry.log-error {
  background: #ffebee;
  border-left-color: #f44336;
}

.log-timestamp {
  color: #666;
  font-size: 0.85rem;
  font-family: 'Courier New', monospace;
}

.log-level {
  font-size: 1.2rem;
  text-align: center;
}

.log-message {
  color: #333;
  font-weight: 500;
}

.log-data {
  color: #666;
  font-size: 0.8rem;
  font-family: 'Courier New', monospace;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .log-entry {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }

  .log-timestamp,
  .log-level,
  .log-message,
  .log-data {
    font-size: 0.8rem;
  }
}

/* Positions actives en temps réel */
.bot-positions {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.positions-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
}

@media (max-width: 1400px) {
  .positions-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 0.75rem;
  }
}

@media (max-width: 1200px) {
  .positions-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }
}

.position-card {
  background: #f9f9f9;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.position-card.profit {
  background: #e8f5e9;
  border-color: #4caf50;
  animation: profitPulse 2s ease-out;
}

.position-card.loss {
  background: #ffebee;
  border-color: #f44336;
  animation: lossPulse 2s ease-out;
}

@keyframes profitPulse {
  0% {
    background: #c8e6c9;
    border-color: #4caf50;
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
  50% {
    background: #a5d6a7;
    box-shadow: 0 0 0 8px rgba(76, 175, 80, 0);
  }
  100% {
    background: #e8f5e9;
    border-color: #4caf50;
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
}

@keyframes lossPulse {
  0% {
    background: #ffcdd2;
    border-color: #f44336;
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.7);
  }
  50% {
    background: #ef9a9a;
    box-shadow: 0 0 0 8px rgba(244, 67, 54, 0);
  }
  100% {
    background: #ffebee;
    border-color: #f44336;
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}

.position-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #4CAF50;
}

.position-card-empty {
  background: #f5f5f5;
  border-style: dashed;
  opacity: 0.6;
}

.position-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.position-symbol {
  font-size: 1.3rem;
  font-weight: bold;
  color: #333;
  letter-spacing: 0.5px;
}

.position-pending-badge {
  background: #fff3e0;
  color: #e65100;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}

.position-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1;
}

.position-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0;
  border-bottom: 1px solid #eee;
  gap: 0.5rem;
}

.position-row:last-child {
  border-bottom: none;
}

.position-row.position-profit-loss {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  border-top: 2px solid #e0e0e0;
  font-weight: 600;
}

.position-label {
  font-size: 0.8rem;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
}

.position-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.position-current-price {
  font-size: 1rem;
  font-weight: bold;
  color: #2196F3;
}

.position-empty-text {
  text-align: center;
  color: #999;
  font-style: italic;
  padding: 2rem 0;
}

.empty-positions {
  grid-column: 1 / -1;
  text-align: center;
  padding: 3rem;
  color: #999;
}

@media (max-width: 768px) {
  .alpaca-bot-page {
    padding: 1rem;
  }

  .alpaca-bot-controls {
    flex-direction: column;
    gap: 1rem;
  }

  .bot-stats-grid {
    grid-template-columns: 1fr;
  }

  .positions-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .transactions-table-container {
    font-size: 0.9rem;
  }

  .transactions-table th,
  .transactions-table td {
    padding: 0.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/AlpacaBot.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;;;;IAIE,iBAAiB;EACnB;AACF;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;IACrC,YAAY;EACd;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8DAA8D;EAC9D,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,wCAAwC;EAC1C;AACF;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".alpaca-bot-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.alpaca-bot-header {\n  margin-bottom: 2rem;\n}\n\n.alpaca-bot-title {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #333;\n  margin: 0 0 0.5rem 0;\n}\n\n.alpaca-bot-subtitle {\n  color: #666;\n  margin: 0;\n}\n\n.bot-config-selector {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.bot-config-selector label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.bot-config-selector select {\n  padding: 8px 12px;\n  font-size: 14px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background: white;\n  color: #1e293b;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  min-width: 200px;\n}\n\n.bot-config-selector select:hover {\n  border-color: #667eea;\n}\n\n.bot-config-selector select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.alpaca-bot-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  background: #f5f5f5;\n  border-radius: 8px;\n  margin-bottom: 2rem;\n}\n\n.bot-status {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.bot-status-indicator {\n  font-size: 1.5rem;\n}\n\n.bot-status-text {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.bot-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.bot-button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.bot-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.start-button {\n  background: #4CAF50;\n  color: white;\n}\n\n.start-button:hover:not(:disabled) {\n  background: #45a049;\n}\n\n.stop-button {\n  background: #f44336;\n  color: white;\n}\n\n.stop-button:hover:not(:disabled) {\n  background: #da190b;\n}\n\n.error-message {\n  padding: 1rem;\n  background: #fee;\n  color: #c33;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #4CAF50;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.bot-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.stat-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid #4CAF50;\n  overflow: hidden;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1.4;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  min-height: 2.8rem;\n  display: flex;\n  align-items: flex-start;\n}\n\n.stat-value {\n  font-size: 1.6rem;\n  font-weight: bold;\n  color: #333;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  line-height: 1.2;\n  max-width: 100%;\n  margin-top: auto;\n}\n\n.stat-value.buy {\n  color: #4CAF50;\n}\n\n.stat-value.sell {\n  color: #f44336;\n}\n\n.stat-value.profit {\n  color: #4CAF50;\n}\n\n.stat-value.loss {\n  color: #f44336;\n}\n\n.stat-sublabel {\n  font-size: 0.75rem;\n  color: #999;\n  margin-top: 4px;\n}\n\n.stat-card-total {\n  border-left-color: #2196F3;\n  background: #f0f7ff;\n}\n\n.stat-value-lg {\n  font-size: 2rem;\n}\n\n.bot-transactions {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.section-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #333;\n  margin: 0 0 1.5rem 0;\n}\n\n.transactions-table-container {\n  overflow-x: auto;\n}\n\n.transactions-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.transactions-table thead {\n  background: #f5f5f5;\n}\n\n.transactions-table th {\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #ddd;\n}\n\n.transactions-table tbody tr {\n  border-bottom: 1px solid #eee;\n}\n\n.transactions-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.transactions-table td {\n  padding: 0.75rem 1rem;\n}\n\n.action-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.action-badge.buy {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.action-badge.sell {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.status-badge.status-filled {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.status-pending,\n.status-badge.status-new,\n.status-badge.status-accepted,\n.status-badge.status-pending_new,\n.status-badge.status-pending_replace,\n.status-badge.status-accepted_for_bidding {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.status-badge.status-partially_filled {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.status-badge.status-failed,\n.status-badge.status-canceled,\n.status-badge.status-expired,\n.status-badge.status-rejected {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.profit {\n  color: #4CAF50;\n  font-weight: 600;\n}\n\n.loss {\n  color: #f44336;\n  font-weight: 600;\n}\n\n.empty-message {\n  text-align: center;\n  padding: 3rem;\n  color: #999;\n}\n\n.bot-logs {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 2rem;\n}\n\n.logs-container {\n  max-height: 500px;\n  overflow-y: auto;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  padding: 1rem;\n  background: #f9f9f9;\n}\n\n.log-entry {\n  display: grid;\n  grid-template-columns: 180px 40px 1fr auto;\n  gap: 1rem;\n  padding: 0.5rem;\n  margin-bottom: 0.5rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  align-items: center;\n  border-left: 3px solid transparent;\n}\n\n.log-entry.log-info {\n  background: #e3f2fd;\n  border-left-color: #2196f3;\n}\n\n.log-entry.log-success {\n  background: #e8f5e9;\n  border-left-color: #4caf50;\n}\n\n.log-entry.log-warning {\n  background: #fff3e0;\n  border-left-color: #ff9800;\n}\n\n.log-entry.log-error {\n  background: #ffebee;\n  border-left-color: #f44336;\n}\n\n.log-timestamp {\n  color: #666;\n  font-size: 0.85rem;\n  font-family: 'Courier New', monospace;\n}\n\n.log-level {\n  font-size: 1.2rem;\n  text-align: center;\n}\n\n.log-message {\n  color: #333;\n  font-weight: 500;\n}\n\n.log-data {\n  color: #666;\n  font-size: 0.8rem;\n  font-family: 'Courier New', monospace;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .log-entry {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n  }\n\n  .log-timestamp,\n  .log-level,\n  .log-message,\n  .log-data {\n    font-size: 0.8rem;\n  }\n}\n\n/* Positions actives en temps réel */\n.bot-positions {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.positions-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 1rem;\n}\n\n@media (max-width: 1400px) {\n  .positions-grid {\n    grid-template-columns: repeat(5, 1fr);\n    gap: 0.75rem;\n  }\n}\n\n@media (max-width: 1200px) {\n  .positions-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem;\n  }\n}\n\n.position-card {\n  background: #f9f9f9;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1rem;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.position-card.profit {\n  background: #e8f5e9;\n  border-color: #4caf50;\n  animation: profitPulse 2s ease-out;\n}\n\n.position-card.loss {\n  background: #ffebee;\n  border-color: #f44336;\n  animation: lossPulse 2s ease-out;\n}\n\n@keyframes profitPulse {\n  0% {\n    background: #c8e6c9;\n    border-color: #4caf50;\n    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);\n  }\n  50% {\n    background: #a5d6a7;\n    box-shadow: 0 0 0 8px rgba(76, 175, 80, 0);\n  }\n  100% {\n    background: #e8f5e9;\n    border-color: #4caf50;\n    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);\n  }\n}\n\n@keyframes lossPulse {\n  0% {\n    background: #ffcdd2;\n    border-color: #f44336;\n    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.7);\n  }\n  50% {\n    background: #ef9a9a;\n    box-shadow: 0 0 0 8px rgba(244, 67, 54, 0);\n  }\n  100% {\n    background: #ffebee;\n    border-color: #f44336;\n    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);\n  }\n}\n\n.position-card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-color: #4CAF50;\n}\n\n.position-card-empty {\n  background: #f5f5f5;\n  border-style: dashed;\n  opacity: 0.6;\n}\n\n.position-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e0e0e0;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n}\n\n.position-symbol {\n  font-size: 1.3rem;\n  font-weight: bold;\n  color: #333;\n  letter-spacing: 0.5px;\n}\n\n.position-pending-badge {\n  background: #fff3e0;\n  color: #e65100;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.position-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.position-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.4rem 0;\n  border-bottom: 1px solid #eee;\n  gap: 0.5rem;\n}\n\n.position-row:last-child {\n  border-bottom: none;\n}\n\n.position-row.position-profit-loss {\n  margin-top: 0.25rem;\n  padding-top: 0.5rem;\n  border-top: 2px solid #e0e0e0;\n  font-weight: 600;\n}\n\n.position-label {\n  font-size: 0.8rem;\n  color: #666;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.position-value {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #333;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.position-current-price {\n  font-size: 1rem;\n  font-weight: bold;\n  color: #2196F3;\n}\n\n.position-empty-text {\n  text-align: center;\n  color: #999;\n  font-style: italic;\n  padding: 2rem 0;\n}\n\n.empty-positions {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 3rem;\n  color: #999;\n}\n\n@media (max-width: 768px) {\n  .alpaca-bot-page {\n    padding: 1rem;\n  }\n\n  .alpaca-bot-controls {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .bot-stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .positions-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .transactions-table-container {\n    font-size: 0.9rem;\n  }\n\n  .transactions-table th,\n  .transactions-table td {\n    padding: 0.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
